import { Button } from '@components/button';
import { ScrollToFormButton } from '@components/scrollToFormButton';
import { classNames } from '@lib/classNames/classNames';
import Link from 'next/link';
import { memo } from 'react';

import { MainButtonParams } from './types';

interface MainButtonProps extends MainButtonParams {
  mainButtonHrefWithUtm?: string;
  className?: string;
}

export const MainButton = memo(
  ({
    mainButtonHrefWithUtm,
    className,
    mainButtonContent,
    mainButtonHref,
    mainButtonVariant = 'primary',
  }: MainButtonProps) => {
    return (
      <>
        {mainButtonHrefWithUtm && (
          <Link
            href={mainButtonHrefWithUtm}
            target="_blank"
            className="max-sm:w-full"
          >
            <Button
              className={classNames({
                cls: 'flex h-14 w-60 items-center justify-center max-sm:w-full',
                additional: [className],
              })}
              variant={mainButtonVariant}
            >
              {mainButtonContent}
            </Button>
          </Link>
        )}
        {!mainButtonHref && (
          <ScrollToFormButton
            className={classNames({
              cls: 'flex h-14 w-60 items-center justify-center max-sm:w-full',
              additional: [className],
            })}
            variant={mainButtonVariant}
          >
            {mainButtonContent}
          </ScrollToFormButton>
        )}
      </>
    );
  },
);

MainButton.displayName = 'MainButton';
